import NotFound from 'pages/not-found';
import { FC } from 'react';
import { Route, Routes } from 'react-router-dom';
import Form from './Form';
import Information from './Information';
import Interviews from './interviews';
import DeclarePastInterview from './interviews/DeclarePastInterview';

const MenteeDetailsRoutes: FC = () => {
  return (
    <Routes>
      <Route path="/" element={<Information />} />
      {/* Note : On retire les "/" initiaux pour les sous-routes pour éviter les conflits */}
      <Route path="form" element={<Form />} />
      <Route path="interviews" element={<Interviews />} />
      
      {/* On place la route spécifique AVANT la route générique /* */}
      <Route 
        path="interviews/DeclarePastInterview" 
        element={<DeclarePastInterview />} 
      />

      {/* Cette route doit TOUJOURS être la dernière */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default MenteeDetailsRoutes;